<template>
    <div class="team__content">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="relative">
            <div class="team__tot wrapper__wpd animate__animated animate__fadeIn">
                <div class="txt" style="left: 10%;width: 40%">
                    <div class="">
                        <div class="title"><span>隐上团队</span></div>
                        <div>
                            精湛的工艺，贴心的服务，多年积累的行业经验
                            —— 只为提升您的体验
                        </div>
                    </div>
                </div>
                <div class="all"><img :src="icon_team1"></div>
            </div>

            <div class="relative">
                <div class="user__list wrapper__wpd">
                    <div class="title wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s"><span>金牌管家</span></div>
                    <div style="height: 200px"></div>
                </div>
                <div class="wrapper__wpd" style="background: #f1f1f1">
                    <el-row :gutter="30" style="position: relative;top: -200px;">
                        <el-col :span="12" @click="preeItem('/strategic')" v-for="(item, index) in houseGoldList" :key="index" class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s" >
                            <el-row class="user__item--li relative" style="padding-top: 20px;">
                                <div class="relative" style="z-index: 10">
                                    <el-col :span="11">
                                        <!--用户头像-->
                                        <div class="user__head relative">
                                            <div class="ewm__bg"><img :src="icon_team3"></div>
                                            <div class="user__bg relative"><img :src="item.image"></div>
                                        </div>
                                        <!--用户签名-->
                                        <div class="user__autograph" :style="{'background':'url('+icon_team4+')', 'background-size': '100% 100%', 'background-repeat': 'no-repeat'}">
                                            <div class="divider"><el-divider>做事理念</el-divider></div>
                                            <div class="des">{{item.sign}}</div>
                                        </div>
                                        <!--用户名+age-->
                                        <el-row :gutter="20" class="user__base--box">
                                            <el-col :span="12">
                                                <div class="user__name">
                                                    <div class="title"><span>{{item.name}}</span></div>
                                                    <div class="tag overtext2">{{item.position}}</div>
                                                </div>
                                            </el-col>
                                            <el-col :span="12">
                                                <div class="user__age">
                                                    <span class="code__number">{{item.year}}</span>年
                                                </div>
                                            </el-col>
                                        </el-row>
                                    </el-col>

                                    <el-col :span="13">
                                        <div class="user__right--des" style="height: 450px;overflow-y: scroll;">
                                            <div>{{item.description}}</div>
                                            <div class="case">
                                                <span>优秀案例：</span><br>
                                                {{item.cases}}
                                            </div>
                                        </div>
                                    </el-col>
                                </div>

                                <div class="online__booking footFm-but transition"  @click.stop="submitShow(item.id)">在线预约</div>
                                <div class="tos"></div>
                                <div class="user__tos"><img :src="item.image"></div>

                            </el-row>
                        </el-col>
                    </el-row>

                </div>
                <div class="user__bk--left"></div>
            </div>

            <div style="position: relative;top: -240px;z-index: 222;background: #fff;">
                <div class="user__list wrapper__wpd deep__user--photo">
                    <div class="title wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                        <span>资深管家团队</span>
                    </div>
                    <div class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s"><img :src="icon_team5" style="width: 100%"></div>
                    <div style="height: 280px"></div>
                </div>
                <div class="wrapper__wpd user__item--samll" style="background: #f1f1f1">
                    <el-row :gutter="30" style="position: relative;top: -200px;">
                        <el-col :span="8" v-for="(item, index) in housekeeperList" :key="index"  class="wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                            <el-row class="user__item--li relative ">
                                <div class="relative" style="z-index: 10">
                                    <el-row :gutter="20">
                                        <el-col :span="12">
                                            <div class="user__head relative">
                                                <div class="ewm__bg"><img :src="icon_team3"></div>
                                                <div class="user__bg relative"><img :src="item.image"></div>
                                            </div>
                                        </el-col>
                                        <el-col :span="12">
                                            <div>
                                                <div class="user__name">
                                                    <div class="title"><span>{{item.name}}</span></div>
                                                    <div class="tag overtext2">{{item.position}}</div>
                                                </div>
                                                <div class="user__autograph" >
                                                    <div class="divider"><span>做事理念</span></div>
                                                    <div class="des">{{item.sign}}</div>
                                                </div>
                                                <div class="user__age">
                                                    <span class="code__number">{{item.year}}</span>年
                                                </div>
                                            </div>
                                        </el-col>
                                    </el-row>
                                    <div class="user__right--des" style="height: 200px;overflow-y: scroll;">
                                        <div>{{item.description}}</div>
                                        <div class="case">
                                            <span>优秀案例：</span><br>
                                            {{item.cases}}
                                        </div>
                                    </div>
                                </div>

<!--                                <div class="online__booking">在线预约</div>-->
                                <div class="tos"></div>
                                <div class="user__tos"><img :src="item.image"></div>

                            </el-row>
                        </el-col>
                    </el-row>

                </div>
            </div>

            <div class="footer__all">
                <Footer></Footer>
            </div>


            <el-dialog title="预约管家" width="30%" center :visible.sync="dialogFormVisible">
                <el-form :model="form">
                    <el-form-item label="您的姓名：" label-width="120px">
                        <el-input v-model="form.name"  clearable></el-input>
                    </el-form-item>
                    <el-form-item label="您的手机：" label-width="120px">
                        <el-input v-model="form.mobile" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="所在城市：" label-width="120px">
                        <el-input v-model="form.city" clearable></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="submitFun()" :loading="isSubmit">确 定</el-button>
                </div>
            </el-dialog>


        </div>

    </div>
</template>

<script>
    import icon_stra from '@/assets/img/add01.png'
    import icon_team1 from '@/assets/img/team1.png'
    import icon_team2 from '@/assets/img/team2.png'
    import icon_team3 from '@/assets/img/team3.png'
    import icon_team4 from '@/assets/img/team4.png'
    import icon_team5 from '@/assets/img/team5.png'

    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'
    import { isPhone } from '@/libs/common'



    export default {
        name: 'Test',
        data (){
            return {
                icon_stra, icon_team1, icon_team2, icon_team3, icon_team4,icon_team5,
                houseGoldList: [],
                housekeeperList: [],

                dialogFormVisible: false,
                form: {
                    name: '',
                    mobile: '',
                    city: ''
                },
                isSubmit: false,
                housekeeper_id: '',
            }
        },
        components: {
            NavSecond,Footer
        },
        methods: {
            /**
             * @description详情
             * */
            getList (is_gold){
                this.$xhr(this.$api.housekeeperList, {pagenum:-1, is_gold}).then(res => {
                    if (is_gold){
                        this.houseGoldList = res.list
                    } else {
                        this.housekeeperList = res.list
                    }
                })
            },
            submitShow (housekeeper_id){
                this.housekeeper_id = housekeeper_id
                this.dialogFormVisible = true
            },
            /**
             * @description预约
             * */
            submitFun (){
                const {city, name, mobile} = this.form
                if(!name){
                    this.$message.error('请输入称呼')
                    return false
                }
                if(!mobile){
                    this.$message.error('请输入联系电话')
                    return false
                }
                if (!isPhone(mobile)){
                    this.$message.error('请输入正确的手机号')
                    return false
                }
                if(!city){
                    this.$message.error('请输入城市')
                    return false
                }
                this.isSubmit = true
                this.$xhr(this.$api.housekeeperNote, Object.assign(this.form, {housekeeper_id: this.housekeeper_id})).then(res => {
                    this.dialogFormVisible = false
                    this.isSubmit = false
                    this.$message({
                        message: '预约成功，稍后会有工作人员联系您，请耐心等待',
                        type: 'success',
                        duration: '3000'
                    });
                })
            },
        },
        mounted() {
            this.$wow.init()
            this.$nextTick(() => {
                this.getList()
                this.getList(1)
            })
        },
    }
</script>
<style  lang="scss" scoped>
    .team__content{
        .title {
            font-size: 32px;
            font-weight: bold;
            color: #010101;
            margin: 40px 0;
            span {
                position: relative;
                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 0;
                    bottom: -10px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }

        }
        .team__tot{
            margin-top: 150px;
            position: relative;
            .all{
                position: relative;
                z-index: 2;
                text-align: right;
                img{
                    width: 60%;
                    height: 600px;
                    object-fit: cover;
                }
            }
            .txt{
                z-index: 3;
                position: absolute;
                left: 0;
                top: 7%;
                height: 513px;
                background: #F1F1F1;
                width: 50%;
                & > div{
                    width: 55%;
                    margin: 0 auto;
                    margin-top: 30%;
                }
            }
        }
        .user__list{
           .title{
               text-align: center;
               margin: 120px 0;
               & > span::after{
                   left: 50%;
                   margin-left: -16px;
               }
           }
        }
        .user__head{
            height: 325px;
            img{
                display: block;
                max-width: 100%;
            }
            .ewm__bg{
                position: absolute;
                z-index: 1;
                img{
                    width: 80%;
                    margin: 0 auto;
                }
            }
            .user__bg{
                z-index: 2;
                height: 100%;
                img{
                    display: block;
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                }
            }
        }
        .user__autograph{
            padding: 0 20px;
            padding-top: 1px;
            padding-bottom: 10px;
            .divider {
                .el-divider__text{
                    color: #F15315;
                }
                .el-divider {
                    background-color: #F15315
                }
                .el-divider--horizontal{
                    height: 2px;
                }
            }
            .des{
                font-size: 16px;
                font-weight: 400;
                color: #000000;
                line-height: 22px;
            }
        }
        .user__base--box {
            padding: 0 20px;
            padding-top: 30px;
            .user__name {
                height: 100px;

                .title {
                    font-size: 28px;
                    margin-top: 0px;
                    margin-bottom: 30px;
                }

                .tag {
                    font-size: 16px;
                    font-weight: 400;
                    color: #000000;
                }
            }


        }
        .user__age {
            font-size: 18px;
            font-weight: bold;
            color: #F15315;
            height: 110px;
            display: -webkit-box;
            -webkit-box-align: end;

            .code__number {
                font-size: 68px;
            }
        }
        .user__right--des{
            padding: 0 20px;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 24px;
            .case{
                margin-top: 20px;
                span{
                    display: inline-block;
                    font-size: 20px;
                    font-weight: 400;
                    color: #F15315;
                    margin-bottom: 5px;
                }
            }
        }
        .online__booking{
            cursor: pointer;
            position: absolute;
            right: 20px;
            bottom: 30px;
            z-index: 10;
            width: 80px;
            height: 36px;
            border: 1px solid #F15315;
            font-size: 16px;
            font-weight: 400;
            color: #F15315;
            line-height: 36px;
            text-align: center;
        }
        .user__item--li{
            overflow: hidden;
            z-index: 10;
            padding-bottom: 20px;
            margin-bottom: 30px;
            .tos{
                z-index: 5;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                background: rgba(255,255,255,0.95);
            }
            .user__tos{
                z-index: 4;
                position: absolute;
                left: 0;
                bottom: 0;
                width: 100%;
                height: 100%;
                text-align: right;
                img{
                    position: absolute;
                    right: -20%;
                    bottom: 0;
                    height: 100%;
                }
            }
        }
        .user__bk--left{
            position: absolute;
            background: #fff;
            width: 10%;
            left: 0;
            bottom: 0;
            height: 500px;
        }
        .deep__user--photo{
            .title{
                padding-top: 120px!important;
            }
            img{
                width: 100%;
            }
        }
        .user__item--samll{
            .el-divider__text{
                background-color: rgba(255,255,255,0.95);
            }
            .user__head{
                height: 240px;
            }
            .user__autograph{
                padding: 0;
                margin-top: 10px;
                margin-bottom: 15px;
                .des{
                    margin-top: 5px;
                    font-size: 14px;
                }
            }
            .user__name{
                .title{
                    margin-top: 0;
                    font-size: 28px;
                    margin-bottom: 35px;
                }
            }
            .user__age{
                height: auto;
                float: right;
            }
            .divider{
                position: relative;
                text-align: center;
                font-size: 14px;
                font-weight: 400;
                color: #F15315;
                span{
                    position: relative;
                    letter-spacing: 2px;
                }
                span::before{
                    content: "";
                    position: absolute;
                    left: -12px;
                    top: 9px;
                    display: block;
                    width: 12px;
                    height: 2px;
                    background: #F15315;
                }
                span::after{
                    content: "";
                    position: absolute;
                    right: -12px;
                    top: 9px;
                    display: block;
                    width: 12px;
                    height: 2px;
                    background: #F15315;
                }

            }
            .user__right--des{
                padding: 15px;
            }
            .user__item--li{
                padding: 10px;
                padding-top: 20px;
            }
        }
        .footer__all{
            position: absolute;
            bottom: 0;
            width: 100%;
            left: 0;
            z-index: 222;
            background: #fff
        }
    }

</style>
